import styles from "./PrimaryInput.module.css"
import React from 'react';
/**
* Props for the PrimaryInput component.
*/ 
interface PrimaryInputProps {
    text?: string, // Label
    onChange?: (value: string| number) => void, // Change event handler
    value?: string | number, // Current value
    className? :string, // Optional additional class
    showLabel?: boolean, // Whether to show label
    placeholder?: string, // Placeholder
    type?: string, // Input type
    min?: number, // Minimal value for input type number
    max?: number // Maximal value for input type number
}
/**
* A primary input component with label and value controls.
*
* @param props PrimaryInput props
* @param {string} props.text - Label
* @param {(value: string|number) => void} props.onChange - Change event handler
* @param {string|number} props.value - Current value
* @param {string} props.className - Optional additional class
* @param {boolean} props.showLabel - Whether to show label
* @param {string} props.placeholder - Placeholder
* @param {string} props.type - Input type
* @param {number} props.min - Minimal value for input type number
* @param {number} props.max - Maximal value for input type number
* @returns TSX.Element
*/
const PrimaryInput: React.FC<PrimaryInputProps> = ({ text = "Primary", type ="text" , onChange, value, className, showLabel, placeholder, min, max}) => {
    
    return(
        <>
        <div className={`${styles.PrimaryInputBlock} ${className ?? ''}`}>
            <div className={styles.PrimaryInputCenter}>
                <input type={type} className={styles.PrimaryInputField}
                onChange={(e)=>onChange && onChange(e.target.value)}
                value={value}
                placeholder={placeholder ? placeholder : ""}
                min={min && min}
                max={max && max}
                />
            </div>
            {showLabel && <div className={styles.PrimaryInputLabel}><p>{text}</p></div>}
        </div>
        </>
    )
};

export default PrimaryInput;